export default __webpack_public_path__ + "static/New-IISc-Map-06ab10bf820f2ff466723b02a24e1551.pdf";